















import Vue from "vue";
import HealthError from "./HealthError.vue";
import HealthOnboarding from "./HealthOnboarding.vue";

export default Vue.extend({
  name: "HealthOnboardingGate",
  components: { HealthError, HealthOnboarding },
  props: {
    error: { type: String, default: "" },
    providerLabel: { type: String, required: true },
    canConnect: { type: Boolean, default: false },
    busy: { type: Boolean, default: false }
  }
});
